module.exports = __webpack_public_path__ + "img/3.8ed853c5.jpg";